// VFX: Lens Flare Burst
// Category: overlays · Tags: lens, flare, anamorphic, light, overlay
// Anamorphic lens flare streaks across frame on cut.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

export default function FxLensFlareBurst600Ms() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const t = frame / durationInFrames;
  // Position travels diagonally across the frame
  const cx = interpolate(t, [0, 1], [width * 0.15, width * 0.85]);
  const cy = interpolate(t, [0, 1], [height * 0.6, height * 0.4]);
  const burst = interpolate(t, [0, 0.15, 0.85, 1], [0, 1, 1, 0], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", overflow: "hidden" }}>
      {/* Backdrop glow */}
      <AbsoluteFill style={{
        background: `radial-gradient(circle at ${cx}px ${cy}px, rgba(255,200,120,${burst * 0.45}) 0%, transparent 40%)`,
      }} />

      {/* Anamorphic horizontal streak */}
      <div style={{
        position: "absolute",
        top: cy - 12, left: 0, width, height: 24,
        background: "linear-gradient(90deg, transparent 0%, rgba(120,200,255,0.95) 50%, transparent 100%)",
        opacity: burst,
        filter: "blur(4px)",
        mixBlendMode: "screen",
      }} />
      <div style={{
        position: "absolute",
        top: cy - 3, left: 0, width, height: 6,
        background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,1) 50%, transparent 100%)",
        opacity: burst,
        filter: "blur(1px)",
        mixBlendMode: "screen",
      }} />

      {/* Core orb */}
      <div style={{
        position: "absolute", left: cx, top: cy,
        width: 80, height: 80, borderRadius: "50%",
        background: "radial-gradient(circle, #fff 0%, rgba(255,220,160,0.7) 35%, transparent 70%)",
        transform: "translate(-50%,-50%)",
        opacity: burst,
        filter: "blur(2px)",
        mixBlendMode: "screen",
      }} />

      {/* Secondary ghosts along the optical axis */}
      {[0.3, 0.55, 0.75].map((p, i) => (
        <div key={i} style={{
          position: "absolute",
          left: interpolate(p, [0, 1], [cx, width - cx]),
          top: interpolate(p, [0, 1], [cy, height - cy]),
          width: 50 - i * 10, height: 50 - i * 10, borderRadius: "50%",
          background: `radial-gradient(circle, hsla(${30 + i * 60},90%,70%,0.6) 0%, transparent 70%)`,
          transform: "translate(-50%,-50%)",
          opacity: burst * 0.7,
          filter: "blur(2px)",
          mixBlendMode: "screen",
        }} />
      ))}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
